import { SoccerIncidentId } from '@collector/sportsapi-client-legacy'

import { VIPIncidentsConfig } from '../../configuration'

export const vipIncidentsConfig: VIPIncidentsConfig<SoccerIncidentId> = {
  incidents: new Set([
    SoccerIncidentId.ShotOnTarget,
    SoccerIncidentId.ShotOffTarget,
    SoccerIncidentId.ShotBlocked,
    SoccerIncidentId.Foul,
    SoccerIncidentId.Offside,
  ]),
}
